<template>
  <div class="classify" id="classify">
    <router-link tag="div" :to="'/list/' + item.id" class="content-classify-box" v-for="item in list" :key="item.id">
      <div class="classify-img">
        <img :src="item.imgUrl ? url + item.imgUrl : defaultimg">
      </div>
      <p>{{item.desc}}</p>
    </router-link>
    <router-link tag="div" to="/category" class="content-classify-box line-three">
      <div class="classify-img">
        <i class="iconfont">&#xe701;</i>
      </div>
      <p>全部类别</p>
    </router-link>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'HomeClassify',
  props: {
    list: Array
  },
  data () {
    return {
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  }
}
</script>

<style scoped>
#classify{ min-height: 100%;}
.classify{ display: flex; flex-wrap: wrap; padding: 0 20px; border-bottom: 10px solid #f6f6f6; margin-top: 18px;}
.content-classify-box{ width: 20%; height: 64px; text-align: center;}
.content-classify-box .iconfont{ display: block; font-size: 20px;}
.line-three .iconfont{ color: #e16e6e; font-size: 28px; padding: 8px;}
.content-classify-box p{ font-size: 12px; margin-top: 3px;}
.content-classify-box{ margin-top: 7px;}
.line-three{ margin-bottom: 25px;}
.classify-img img{ width: 90%; height: auto; padding-top: 2px;}
.classify-img{ background-color: #efefef; width: 45px; height: 45px; margin-left: auto; margin-right: auto;border-radius: 50%; overflow: hidden;}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Classify.vue